import React from "react";
import "./FileInput.scss";
import {
  CloseOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import { openNotificationWithIcon } from "../../../../src/utilities/notificationWithIcon";

const noop = () => {};

const FileInput = ({ limitFiles, value, onChange = noop, ...rest }) => (
  <div className="file-input-custom">
    <label className="label-file-input-custom">
      <input
        {...rest}
        type="file"
        className="inputfile"
        onChange={(e) => {
          if (limitFiles && Array.from(e.target.files).length > limitFiles) {
            e.preventDefault();
            openNotificationWithIcon(
              "warning",
              `No puedes subir más de ${limitFiles} archivo(s)`,
              ""
            );
            return;
          } else {
            let currentValues = e.target.files;

            if (!e.target.multiple) {
              onChange([...currentValues]);
              return;
            }

            let newValues = [];
            for (let index = 0; index < currentValues.length; index++) {
              newValues.push(currentValues[index]);
            }
            if (!value) onChange([...newValues]);
            if (value) onChange([...value.concat(newValues)]);
          }
        }}
      />
      <UploadOutlined /> Cargar archivos
    </label>
    {Boolean(value?.length) && (
      <div>
        {value.map((f, key) => {
          return (
            <Row className="file-input-custom-name" key={key}>
              <Col xs={1}>
                <PaperClipOutlined />
              </Col>
              <Col xs={17}>{f.name}</Col>
              <Col xs={6}>
                <Button
                  icon='close'
                  size="small"
                  onClick={() => {
                    let filtered = value.filter((el) => {
                      return el.name != f.name;
                    });
                    onChange([...filtered]);
                  }}
                />
              </Col>
            </Row>
          );
        })}
      </div>
    )}
  </div>
);

export default FileInput;
